import { render, staticRenderFns } from "./BuildingMap.vue?vue&type=template&id=686a2830&"
import script from "./BuildingMap.vue?vue&type=script&lang=js&"
export * from "./BuildingMap.vue?vue&type=script&lang=js&"
import style0 from "./BuildingMap.vue?vue&type=style&index=0&id=686a2830&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports